import type { AdminBlastDoc } from '@bb/domain/dist/schemas';

export type AnnouncementType = 'draft' | 'sent' | 'scheduled';

export type AnnouncementsResponse = {
  announcements: AdminBlastDoc[];
  count: number;
  limit?: number;
};

export const ANNOUNCEMENT_USER_TYPE_MAP = {
  'Global Admins': 'GLOBAL_ADMIN',
  'Branch Admins': 'BRANCH_ADMIN',
  'Team Admins': 'TEAM_ADMIN',
  Agents: 'AGENT',
};

export type AnnouncementUser = keyof typeof ANNOUNCEMENT_USER_TYPE_MAP;

type AnnouncementUserRole =
  (typeof ANNOUNCEMENT_USER_TYPE_MAP)[AnnouncementUser];

export type AnnouncementContent = {
  replyTo: string;
  subject: string;
  body: string;
};

export type AnnouncementFormValues = AnnouncementContent & {
  sendLater: boolean;
  delay?: Date;
};

export type AnnouncementFormData = Omit<AnnouncementFormValues, 'sendLater'> & {
  userIds: { id: string }[];
  groups: Array<{
    id: string;
    name: string;
    type?: string;
    userCount?: number;
  }>;
  locations: Record<number, boolean>;
  omitIds: string[];
  omitRoles: AnnouncementUserRole[];
};
